/* Make an Offer (ADR 117) — modal del comprador en el storefront.
 * Requiere login: la identidad va firmada por CardVault (ADR 216, `vault-identidad.js`);
 * `vault_user` solo sirve para saber si hay que mandar a iniciar sesión. Lee la variante
 * seleccionada del form de producto y su precio del JSON inyectado, abre un modal
 * estilo CardVault (ancla + chips + barra de probabilidad + piso anti-lowball) y
 * hace POST autenticado a cards.the-vault.mx/api/offers. */
(function () {
  var VAULT = window.VaultIdentidad;
  var CARDVAULT_ORIGIN = VAULT.origen;
  var API = CARDVAULT_ORIGIN + '/api/offers';
  var FLOOR_PCT = 0.75; // no se aceptan ofertas por debajo del 75% del precio de lista

  function getVaultUser() {
    return VAULT.usuarioVisible();
  }

  function mxn(n) {
    return '$' + Number(n).toLocaleString('es-MX', { maximumFractionDigits: 2 });
  }

  function getVariantPrices() {
    var el = document.querySelector('[data-vault-offer-variants]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }

  function getSelectedVariantId(btn) {
    var formId = btn.getAttribute('data-product-form');
    var input = null;
    if (formId) input = document.querySelector('#' + formId + ' [name="id"]');
    if (!input) input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return input ? input.value : null;
  }

  // Banda heurística de probabilidad (v1, sin histórico aún).
  function band(discountPct) {
    if (discountPct <= 10) return { key: 'alta', label: 'Probabilidad alta', color: '#22c55e', pct: 25 };
    if (discountPct <= 20) return { key: 'media', label: 'Probabilidad media', color: '#f59e0b', pct: 60 };
    if (discountPct <= 25) return { key: 'baja', label: 'Probabilidad baja', color: '#f97316', pct: 90 };
    return { key: 'bloq', label: 'Oferta demasiado baja', color: '#ef4444', pct: 100 };
  }

  function buildModal(cardName, listPrice, onSubmit) {
    var floor = Math.round(listPrice * FLOOR_PCT * 100) / 100;

    var overlay = document.createElement('div');
    overlay.className = 'vault-offer-overlay';

    var modal = document.createElement('div');
    modal.className = 'vault-offer-modal';
    overlay.appendChild(modal);

    modal.innerHTML =
      '<button type="button" class="vault-offer-close" aria-label="Cerrar">&times;</button>' +
      '<h3 class="vault-offer-title">Hacer una oferta</h3>' +
      '<p class="vault-offer-cardname"></p>' +
      '<p class="vault-offer-anchor">Precio de lista: <strong></strong></p>' +
      '<div class="vault-offer-chips"></div>' +
      '<div class="vault-offer-inputrow">' +
        '<span class="vault-offer-currency">$</span>' +
        '<input type="number" class="vault-offer-amount" inputmode="decimal" min="0" step="1" placeholder="Tu oferta">' +
        '<span class="vault-offer-pct"></span>' +
      '</div>' +
      '<div class="vault-offer-bar"><div class="vault-offer-bar__fill"></div></div>' +
      '<p class="vault-offer-bar__label"></p>' +
      '<textarea class="vault-offer-msg" rows="2" maxlength="500" placeholder="Mensaje al vendedor (opcional)"></textarea>' +
      '<p class="vault-offer-error" style="display:none;"></p>' +
      '<div class="vault-offer-actions">' +
        '<button type="button" class="vault-offer-cancel">Cancelar</button>' +
        '<button type="button" class="vault-offer-submit" disabled>Enviar oferta</button>' +
      '</div>' +
      '<p class="vault-offer-note">Tu oferta expira en 48 h.</p>';

    modal.querySelector('.vault-offer-cardname').textContent = cardName;
    modal.querySelector('.vault-offer-anchor strong').textContent = mxn(listPrice);

    var amountEl = modal.querySelector('.vault-offer-amount');
    var pctEl = modal.querySelector('.vault-offer-pct');
    var fillEl = modal.querySelector('.vault-offer-bar__fill');
    var barLabel = modal.querySelector('.vault-offer-bar__label');
    var submitEl = modal.querySelector('.vault-offer-submit');
    var errorEl = modal.querySelector('.vault-offer-error');

    // Chips de descuento rápido.
    var chips = modal.querySelector('.vault-offer-chips');
    [5, 10, 15].forEach(function (d) {
      var c = document.createElement('button');
      c.type = 'button';
      c.className = 'vault-offer-chip';
      c.textContent = '-' + d + '%';
      c.addEventListener('click', function () {
        amountEl.value = (Math.round(listPrice * (1 - d / 100) * 100) / 100).toString();
        update();
      });
      chips.appendChild(c);
    });

    function update() {
      errorEl.style.display = 'none';
      var amount = parseFloat(amountEl.value);
      if (!amount || amount <= 0) {
        pctEl.textContent = '';
        fillEl.style.width = '0%';
        barLabel.textContent = '';
        submitEl.disabled = true;
        return;
      }
      var discountPct = Math.max(0, Math.round((1 - amount / listPrice) * 100));
      pctEl.textContent = '-' + discountPct + '%';
      var b = band(discountPct);
      fillEl.style.width = b.pct + '%';
      fillEl.style.backgroundColor = b.color;
      barLabel.textContent = b.label;
      barLabel.style.color = b.color;

      if (amount >= listPrice) {
        submitEl.disabled = true;
        barLabel.textContent = 'Debe ser menor al precio de lista';
        barLabel.style.color = '#ef4444';
      } else if (amount < floor) {
        submitEl.disabled = true;
        barLabel.textContent = 'Ofertas tan bajas no se aceptan (mínimo ' + mxn(floor) + ')';
        barLabel.style.color = '#ef4444';
      } else {
        submitEl.disabled = false;
      }
    }

    amountEl.addEventListener('input', update);

    function close() {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      document.removeEventListener('keydown', onKey);
    }
    function onKey(e) { if (e.key === 'Escape') close(); }
    document.addEventListener('keydown', onKey);

    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    modal.querySelector('.vault-offer-close').addEventListener('click', close);
    modal.querySelector('.vault-offer-cancel').addEventListener('click', close);

    submitEl.addEventListener('click', function () {
      var amount = parseFloat(amountEl.value);
      submitEl.disabled = true;
      submitEl.textContent = 'Enviando…';
      onSubmit(amount, modal.querySelector('.vault-offer-msg').value, {
        showError: function (msg) {
          errorEl.textContent = msg;
          errorEl.style.display = 'block';
          submitEl.disabled = false;
          submitEl.textContent = 'Enviar oferta';
        },
        success: function () {
          modal.innerHTML =
            '<button type="button" class="vault-offer-close" aria-label="Cerrar">&times;</button>' +
            '<div class="vault-offer-success">' +
              '<div class="vault-offer-success__check">✓</div>' +
              '<h3>¡Oferta enviada!</h3>' +
              '<p>Les avisamos a los vendedores. Si alguien acepta, te llega el link de pago.</p>' +
              '<button type="button" class="vault-offer-submit vault-offer-done">Listo</button>' +
            '</div>';
          modal.querySelector('.vault-offer-close').addEventListener('click', close);
          modal.querySelector('.vault-offer-done').addEventListener('click', close);
        }
      });
    });

    document.body.appendChild(overlay);
    amountEl.focus();
  }

  function handleClick(btn) {
    var user = getVaultUser();
    if (!user) { window.location.href = CARDVAULT_ORIGIN + '/login'; return; }

    var variantId = getSelectedVariantId(btn);
    var prices = getVariantPrices();
    var listPrice = variantId ? prices[variantId] : null;
    if (!variantId || !listPrice) {
      alert('No pudimos leer el precio de esta carta. Recarga la página e intenta de nuevo.');
      return;
    }
    var cardName = btn.getAttribute('data-card-name') || 'esta carta';

    buildModal(cardName, listPrice, function (amount, message, cb) {
      /* Una oferta es un compromiso económico: la identidad con la que se
         manda va firmada y la pone el navegador, no este script (ADR 216). */
      VAULT.asegurar()
        .then(function () {
          return fetch(API, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({ variant_id: variantId, card_name: cardName, amount: amount, message: message || null })
          });
        })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
        })
        .then(function (r) {
          if (r.ok) { cb.success(); return; }
          var msg = (r.data && r.data.error) || 'No se pudo enviar la oferta.';
          cb.showError(msg);
        })
        .catch(function () { cb.showError('Error de red. Revisa tu conexión e intenta de nuevo.'); });
    });
  }

  function initShareButtons() {
    var btns = document.querySelectorAll('.vault-share-btn');
    btns.forEach(function (btn) {
      if (btn.getAttribute('data-share-init')) return;
      btn.setAttribute('data-share-init', '1');
      btn.addEventListener('click', function () {
        var url = btn.getAttribute('data-share-url');
        var title = btn.getAttribute('data-share-title');
        if (navigator.share) {
          navigator.share({ title: title, url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function () {
            btn.classList.add('copied');
            setTimeout(function () { btn.classList.remove('copied'); }, 1500);
          }).catch(function () {});
        }
      });
    });
  }

  function init() {
    initShareButtons();
    var btns = document.querySelectorAll('[data-vault-offer]');
    btns.forEach(function (btn) {
      if (btn.getAttribute('data-vault-offer-init')) return;
      btn.setAttribute('data-vault-offer-init', '1');
      var box = btn.closest('[data-vault-offer-box]');
      if (box) box.style.display = '';
      else btn.style.display = '';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        handleClick(btn);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
